import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SiteFooter from '@/components/SiteFooter';
import { ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const listingId = params.get('listing_id');

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--bg)', color: 'var(--text)', fontFamily: 'var(--font-sans)' }}>
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="flex justify-center">
            <ArrowLeft size={48} strokeWidth={1.5} style={{ color: 'var(--text-muted)' }} />
          </div>
          <h1 className="text-3xl font-light" style={{ fontFamily: 'var(--font-serif)' }}>Payment cancelled</h1>
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            You cancelled the payment. Your listing has been saved as a draft — you can publish it at any time.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
            <Link
              to="/dashboard/listings"
              data-testid="back-to-drafts-btn"
              className="px-6 py-2.5 text-sm font-medium text-white"
              style={{ backgroundColor: 'var(--text)' }}
            >
              Back to my listings
            </Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
